// 判断是否为推广页
export const isAd = () => {
  return process.env.VUE_APP_IS_AD === 'true'
}

// 获取神策数据上报地址
export const getSensorsServerUrl = () => {
  return process.env.VUE_APP_SENSOR_URL || ''
}

// 返回推广体验课基础地址
export const getExperienceCourseBaseUrl = () => {
  return process.env.VUE_APP_QRCODE_BASE_URL
}

// 是否使用其他顶级域名备案号
export const isOtherICP = () => {
  return !!process.env.VUE_APP_NEW_DOMAIN
}

// 根据路由名称，转成埋点 $title 中文
export const convertRouteNameToTitle = (routeName) => {
  switch (routeName) {
    case 'Home':
      return '体验课落地页（首页）'
    case 'Course':
      return isAd() ? '体验课落地页（报名上课）' : '体验课落地页（课程体系）'
    case 'Download':
      return '体验课落地页（下载中心）'
  }
}

//  判断是否在移动端打开
export const isMobile = () => {
  const ua = navigator.userAgent
  return !!ua.match(
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  )
}
